<template>
    <div class="simple-row">
        <div class="left">
            <swb-file-upload :custFileds="custFileds" :fileGroup="fileGroup" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="multipleFile"></swb-file-upload>
        </div>
        <div class="right">
            <a class="swb-btn swb-btn-link" @click="downloadTemplate" v-if="downloadUrl != null || (downloadFunc != null && typeof downloadFunc == 'function')">下载导入模板</a>
            <a class="swb-btn swb-btn-link" @click="downloadDesc" v-if="downloadDescTxt">导入说明</a>
        </div>
    </div>
</template>


<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    export default{
        name: 'swb-file-upload-group',
        desc: '通用文件上传',
        props: {
            fileGroup: {
                type: String,
                default: null
            },
            multipleFile: {
                type: Boolean,
                default: false
            },
            downloadUrl: {
                type: String,
                default: null
            },
            downloadFunc: {
                type: Function
            },
            showFormatElpx: {
                type: Function
            },
            custFileds: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                downloadDescTxt: false,
            }
        },
        created: function () {
            if(!Utils.isNoB(this.showFormatElpx) && typeof this.showFormatElpx == 'function') {
                this.downloadDescTxt = true;
            }
        },
        methods: {
            //
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析文件");
            },
            //上传进度处理
            onProgress: function (progress) {
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                this.theLoader.hide();
                if(result.type === 'info') {
                    //
                    this.$emit('notity-upload-done', result);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            downloadTemplate: function () {
                let downloadUrl = this.downloadUrl;
                let downloadFunc = this.downloadFunc;
                if(downloadUrl != null) {
                    // 下载模版
                    Utils.setPageUrl(getAppUrl(downloadUrl), '_blank');
                } else if(downloadFunc != null && typeof downloadFunc == 'function') {
                    this.downloadFunc();
                }
            },
            downloadDesc: function () {
                // let downloadDescTxt = this.downloadDescTxt;
                this.showFormatElpx();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/FileUploadGroupDlg.vue